import {useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useIsMobile} from "@brg/ui";
import {useMemo} from "react";
import {AppTester} from "../../../../supporting";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {ComingSoonTab} from "../components/ComingSoonTab";
import {NAVBAR_TAB_NAMES} from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const useGetAboutTabs = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const isMobile = useIsMobile();
    const {
        isBooks,
        isFashionDeziiign,
        isProDeziiign,
        isGameDeziiign,
        isAgeytomesh,
        isAcademy,
        isDeziiign,
        isDeziiignMain,
        isLPUDesign,
    } = useAppTester();
    const isLectureMediiia = AppTester.isLectureMediiia()
    const isGeoDafes = AppTester.isGeoDafes()
    const isMediiiaMain = AppTester.isMediiiaMain()
    const isMediiiaStories = AppTester.isMediiiaStories()
    const isCreativeCity = isAcademy
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isCompetition = AppTester.isCompetition();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHseAnimation = AppTester.isHseAnimation();

    const content = useMemo(() => {

        if (isAgeytomesh || isHseAnimation) {
            return <ComingSoonTab>{t('nav.about_us')}</ComingSoonTab>
        }
        if (isLPUDesign) {
            return <ComingSoonTab>{t('nav.about_university')}</ComingSoonTab>
        }
        if (isLectureMediiia || isContinuumSite) {
            return <ComingSoonTab>{t('nav.about_project')}</ComingSoonTab>
        }
        if (isCompetition && !isMobile) {
            return t('tab_names.about_competition_project')
        }
        if (isGalllleryArt) {
            return t('nav.club')
        }

        return <>{t('nav.about_project')}</>
    }, [isAgeytomesh, isHseAnimation, isMobile, isGameDeziiign, isBooks, isFashionDeziiign, isProDeziiign, isLectureMediiia, isMediiiaMain, t])

    return {
        [NAVBAR_TAB_NAMES.about]: {
            content: content,
            disabled: isAgeytomesh || isHseAnimation || isLectureMediiia  || isContinuumSite || isLPUDesign,
            active: location.pathname.startsWith('/about'),
            linkTo: () => {
                if (isBooks) {
                    return CreateExternalLinkTo.gallllery('/about#books')
                }
                if (isMediiiaStories) {
                    return "https://tellingstories.ru/"
                }

                if (isGalllleryArt || isMediiiaMain) {
                    return '/about'
                }
                if (isDeziiign && !isDeziiignMain) {
                    return CreateExternalLinkTo.deziiign('/about')
                }
                if (isGeoDafes) {
                    return "https://dafes.org"
                }
                if (isCreativeCity) {
                    return "https://creative.hse.ru/creativecity"
                }

                return '/about'
            },
            external: isBooks || isMediiiaStories || isGeoDafes || isCreativeCity,
        },
    }
}import {useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useIsMobile} from "@brg/ui";
import {useMemo} from "react";
import {AppTester} from "../../../../supporting";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {ComingSoonTab} from "../components/ComingSoonTab";
import {NAVBAR_TAB_NAMES} from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const useGetAboutTabs = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const isMobile = useIsMobile();
    const {
        isBooks,
        isFashionDeziiign,
        isProDeziiign,
        isGameDeziiign,
        isAgeytomesh,
        isAcademy,
        isDeziiign,
        isDeziiignMain,
        isLPUDesign,
    } = useAppTester();
    const isLectureMediiia = AppTester.isLectureMediiia()
    const isGeoDafes = AppTester.isGeoDafes()
    const isMediiiaMain = AppTester.isMediiiaMain()
    const isMediiiaStories = AppTester.isMediiiaStories()
    const isCreativeCity = isAcademy
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isCompetition = AppTester.isCompetition();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHseAnimation = AppTester.isHseAnimation();

    const content = useMemo(() => {

        if (isAgeytomesh || isHseAnimation) {
            return <ComingSoonTab>{t('nav.about_us')}</ComingSoonTab>
        }
        if (isLPUDesign) {
            return <ComingSoonTab>{t('nav.about_university')}</ComingSoonTab>
        }
        if (isLectureMediiia || isContinuumSite) {
            return <ComingSoonTab>{t('nav.about_project')}</ComingSoonTab>
        }
        if (isCompetition && !isMobile) {
            return t('tab_names.about_competition_project')
        }
        if (isGalllleryArt) {
            return t('nav.club')
        }

        return <>{t('nav.about_project')}</>
    }, [isAgeytomesh, isHseAnimation, isMobile, isGameDeziiign, isBooks, isFashionDeziiign, isProDeziiign, isLectureMediiia, isMediiiaMain, t])

    return {
        [NAVBAR_TAB_NAMES.about]: {
            content: content,
            disabled: isAgeytomesh || isHseAnimation || isLectureMediiia  || isContinuumSite || isLPUDesign,
            active: location.pathname.startsWith('/about'),
            linkTo: () => {
                if (isBooks) {
                    return CreateExternalLinkTo.gallllery('/about#books')
                }
                if (isMediiiaStories) {
                    return "https://tellingstories.ru/"
                }

                if (isGalllleryArt || isMediiiaMain) {
                    return '/about'
                }
                if (isDeziiign && !isDeziiignMain) {
                    return CreateExternalLinkTo.deziiign('/about')
                }
                if (isGeoDafes) {
                    return "https://dafes.org"
                }
                if (isCreativeCity) {
                    return "https://creative.hse.ru/creativecity"
                }

                return '/about'
            },
            external: isBooks || isMediiiaStories || isGeoDafes || isCreativeCity,
        },
    }
}